module.exports = [{"key":"Forvaltningsbudsjett","text":"Forvaltningsbudsjett"},{"key":"Endringsbudsjett","text":"Endringsbudsjett"},{"key":"Fast-track","text":"Fast-track"},{"key":"SO","text":"SO"},{"key":"Annen","text":"Annen"}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/financing.json
// module id = 700
// module chunks = 0